
<!-- <button  class="btn btn-secondary" (click)="mostrarArchivo();" [disabled]="!base64 || base64 && base64.length < 3?true:false" >{{nombreArchivo}}</button> -->

<button pButton pRipple (click)="mostrarArchivo();" type="button" icon="pi pi-download" class="p-button-rounded p-button-info p-button-text"></button>

<p-dialog [(visible)]="displayModal" [modal]="true" [style]="{width: '100vw'}" [maximizable]="true">
    <ng-template pTemplate="header">
      <h4>Archivo</h4>
    </ng-template>
    <ng-template pTemplate="content">
      <iframe *ngIf="fileUrl" [src]="fileUrl" width="100%" height="700px"></iframe>
    </ng-template>
</p-dialog>
